var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditAiSpark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9AA2A",
    d: "M9.6 12.4c1-.01 4.5-.15 5.4.13.08.02.15.07.2.14.07.1.11.19.1.34-.02.4-5.7 8.4-6.3 8.9-.22.03-.46.04-.68.05-1.54.01-3.12.11-4.65.02-.32-.02-.78-.06-1-.09-.13-.16-.17-.33-.14-.54.04-.24 5.04-7.3 5.6-8.06.18-.23.36-.43.59-.6l.92-.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9AA2A",
    d: "M5.5 5.4c1.82-.07 3.79-.02 5.62.02.54.01 1.38 1.34 1.68 1.77 1.51 2.1 3 4.22 4.54 6.3.37.5.68 1.1.05 1.42-.09.04-.18.06-.28.06l-3.47.01c-.78 0-1.61.04-2.38-.06-.22-.03-.55-.41-.69-.6-1.83-2.5-3.56-5.07-5.38-7.57-.47-.64-.3-.93.3-1.34h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14.6 12.7c.07-.08.17-.13.28-.13.2 0 .37.02.5.17.29.35.57.75.84 1.12l1.67 2.33 2.13 2.95c.18.25.38.55.57.79 2.07 2.52-.55 2.11-2.57 2.17-.59 0-2.83.02-3.11-.22-.63-.54-3.22-4.05-3.36-4.67.16-.54 2.4-3.78 3.06-4.51h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M15.3 5.4c1.43-.01 3.98-.14 5.46.09.31.05.6.64.31 1.07-.5.77-1.07 1.55-1.61 2.31-1.12 1.57-2.22 3.14-3.32 4.7-.3.47-.58 1.09-1.14 1.15-.16.02-.32-.05-.43-.17-.73-.78-2.95-3.86-3.16-4.35.5-1 1.43-2.06 2.06-3.03.44-.67 1.01-1.64 1.83-1.77v0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditAiSpark);
export default __webpack_public_path__ + "static/media/auditAiSpark.a87616963a7abd90871a1c94674ff57c.svg";
export { ForwardRef as ReactComponent };